import { render, staticRenderFns } from "./wzindex.vue?vue&type=template&id=039d4362&scoped=true"
import script from "./wzindex.vue?vue&type=script&lang=js"
export * from "./wzindex.vue?vue&type=script&lang=js"
import style0 from "./wzindex.vue?vue&type=style&index=0&id=039d4362&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d4362",
  null
  
)

export default component.exports